import type { PropsWithChildren } from 'react'
import { Popover } from '@sunwebgroup/uds-ui/popover'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import * as React from 'react'
import { BaseInput } from '../BaseInput'
import { DropdownMultiselectContext } from './context'
import styles from './Selection.module.css'

export function Selection({ children, className, ...rest }: PropsWithChildren<{ className?: string }>) {
  const { selectedValues, disabled, placeholder } = React.use(DropdownMultiselectContext)
  const hasValue = selectedValues.length > 0

  const content = (
    <BaseInput.Root className={className} disabled={disabled} {...rest}>
      <BaseInput.Box tabIndex={disabled ? undefined : 0} hasValue={hasValue}>
        {hasValue
          ? (
              <BaseInput.Content>
                <div className={cn(styles.chips, disabled && styles.chipsDisabled)}>{children}</div>
              </BaseInput.Content>
            )
          : (
              <Typography variant="body-m-regular-tight" className={styles.placeholder}>{placeholder}</Typography>
            )}
      </BaseInput.Box>
      <BaseInput.ChevronDown />
    </BaseInput.Root>
  )

  return <Popover.Trigger>{content}</Popover.Trigger>
}
